import { PLATFORM } from 'aurelia-framework';
import { roles } from 'routes';

export const report_routes = [
  {
    route: 'reports/service-storage-report',
    name: 'service-storage-report',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-storage-report') },
      side: { moduleId: null },
    },
    title: 'reports.servicestationstoragereportheader',
  },
  {
    route: 'reports/service-repairs-report',
    name: 'service-repairs-report',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-repairs-report') },
      side: { moduleId: null },
    },
    title: 'reports.servicerepairsreportheader',
  },
  {
    route: 'reports/service-antifouling-report',
    name: 'service-antifouling-report',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-antifouling-report') },
      side: { moduleId: null },
    },
    title: 'reports.serviceantifoulingreportheader',
  },
  {
    route: 'reports/service-statistics',
    name: 'service-statistics',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-statistics') },
      side: { moduleId: null },
    },
    title: 'reports.servicestatistics.title',
  },
  {
    route: 'reports/service-kpis',
    name: 'service-kpis',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-kpis/service-kpis') },
      side: { moduleId: null },
    },
    title: 'reports.servicekpis.title',
  },
  {
    route: 'reports/service-kpis/antifouling',
    name: 'service-kpi-antifouling',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-kpis/service-kpi-antifouling') },
      side: { moduleId: null },
    },
    title: 'servicestation.kpisTab',
  },
  {
    route: 'reports/service-kpis/service-kpis/estimates-service-queue',
    name: 'service-kpi-estimates-service-queue',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-kpis/service-kpi-estimates-service-queue') },
      side: { moduleId: null },
    },
    title: 'reports.estimateServiceQueue',
  },
  {
    route: 'reports/service-hours-report',
    name: 'service-hours-report',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-hours-report') },
      side: { moduleId: null },
    },
    title: 'reports.servicehoursreport.title',
  },
  {
    route: 'reports/service-shrink-uptake-report',
    name: 'service-shrink-uptake-report',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-shrink-uptake-report') },
      side: { moduleId: null },
    },
    title: 'reports.shrinkUptake.title',
  },
  {
    route: 'reports/service-backlog',
    name: 'service-backlog',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-backlog') },
      side: { moduleId: null },
    },
    title: 'reports.servicebacklog.title',
  },
  {
    route: 'reports/service-month-report',
    name: 'service-month-report',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-month-report') },
      side: { moduleId: null },
    },
    title: 'reports.servicemonthreport.title',
  },
  {
    route: 'reports/service-week-report',
    name: 'service-week-report',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-week-report/service-week-report') },
      side: { moduleId: null },
    },
    title: 'reports.serviceweekreport.title',
  },
  {
    route: 'reports/service-tracking-productionnr-report',
    name: 'service-tracking-productionnr-report',
    settings: { roles: [roles.superService, roles.serviceuser], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/service-tracking-productionnr-report') },
      side: { moduleId: null },
    },
    title: 'reports.trackingProductionNr',
  },
  {
    route: 'reports/newnet-month-hourly-consumption-and-impregnation',
    name: 'newnet-month-hourly-consumption-and-impregnation',
    settings: { roles: [roles.sales], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/newnet-month-report') },
      side: { moduleId: null },
    },
    title: 'reports.newnetmonthreport.title',
  },
  {
    route: 'reports/newnet-antifouling-report',
    name: 'newnet-antifouling-report',
    settings: { roles: [roles.sales], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/newnet-antifouling-report') },
      side: { moduleId: null },
    },
    title: 'reports.newnetantifouling.title',
  },
  {
    route: 'reports/newnet-tracking-productionnr-report',
    name: 'newnet-tracking-productionnr-report',
    settings: { roles: [roles.sales, roles.superService], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/newnet-tracking-productionnr-report') },
      side: { moduleId: null },
    },
    title: 'reports.trackingProductionNr',
  },
  {
    route: ['reports'],
    name: 'reports',
    nav: true,
    settings: {
      roles: [roles.sales, roles.superService, roles.serviceuser, roles.pensSales, roles.pensAdministrator, roles.mooringSeller, roles.mooringAdministrator],
      searchable: true,
    },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/reports/reports') },
      side: { moduleId: null },
    },
    title: 'general.reports',
    route_base: 'reports',
    section: 'admin',
  },
];
